module.exports = __webpack_public_path__ + "24712f6c47821394fba7942fbb52c3b2.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/bower_components/Ionicons/fonts/ionicons.ttf?v=2.0.0
// module id = 268
// module chunks = 0